import z from "zod/v4";
import { BasePathParamsSchema, defineEndpoint, defineResource } from "@visioni/a3s-client-api";
import { FEATURE_NAME } from "../constants";

// intervalStartLocal uses z.string() — the entity may store +HHMM (no colon)
// which z.iso.datetime({offset}) rejects.
export const TenantScenarioBucketItem = z.object({
  intervalStartUtc: z.iso.datetime(),
  intervalEndUtc: z.iso.datetime(),
  intervalStartLocal: z.string(),
  bus: z.number().nonnegative().int(),
  car: z.number().nonnegative().int(),
  human: z.number().nonnegative().int(),
  bike: z.number().nonnegative().int(),
  truck: z.number().nonnegative().int(),
  otherVehicle: z.number().nonnegative().int(),
  missingIntervals: z.array(z.object({ start: z.iso.datetime(), end: z.iso.datetime() })),
});

export type TenantScenarioBucketItemWire = z.input<typeof TenantScenarioBucketItem>;
export type TenantScenarioBucketItem = z.output<typeof TenantScenarioBucketItem>;

export const TenantScenarioBucketList = z.array(TenantScenarioBucketItem);

export type TenantScenarioBucketListWire = z.input<typeof TenantScenarioBucketList>;
export type TenantScenarioBucketList = z.output<typeof TenantScenarioBucketList>;

export const ListBucketsPathParams = BasePathParamsSchema.extend({
  scenarioUuid: z.string().min(1),
});
export type ListBucketsPathParams = z.output<typeof ListBucketsPathParams>;

export const ListBucketsQueryParams = z.object({
  from: z.iso.datetime(),
  to: z.iso.datetime(),
});
export type ListBucketsQueryParams = z.output<typeof ListBucketsQueryParams>;

export const bucketsResource = defineResource({
  feature: FEATURE_NAME,
  resource: "scenarios/{scenarioUuid}/buckets",
  resourcePathSchema: z.object({ scenarioUuid: z.string().min(1) }),
  scope: "camera",
});

export const listBucketsEndpoint = defineEndpoint(bucketsResource, {
  responseSchema: TenantScenarioBucketList,
  querySchema: ListBucketsQueryParams,
});
